import type { LiveVideo } from '@/signalr';
import { VideoRecordingListItemComponent } from './VideoRecordingListItemComponent';

export type VideoRecordingListComponentProps = {
  incidentId: string;
  liveVideos: readonly LiveVideo[];
};

export function VideoRecordingListComponent({ incidentId, liveVideos }: VideoRecordingListComponentProps) {
  if (liveVideos.length === 0) {
    return (
      <div className="alert alert-warning" role="alert">
        No video found
      </div>
    );
  }

  return (
    <div className="list-group list-group-flush">
      {liveVideos.map((liveVideo) => (
        <VideoRecordingListItemComponent key={liveVideo.id} incidentId={incidentId} liveVideo={liveVideo} />
      ))}
    </div>
  );
}
